export type BoardJoinLimitErrorCode =
  | 'user_board_plan_limit_exceeded'
  | 'user_board_overage_payment_required';

export const BOARD_JOIN_LIMIT_ERROR_CODES: BoardJoinLimitErrorCode[] = [
  'user_board_plan_limit_exceeded',
  'user_board_overage_payment_required',
];

export interface BoardJoinLimitContent {
  title: string;
  message: string;
  secondary: string;
  ctaLabel: string;
}

const BOARD_JOIN_LIMIT_CONTENT: Record<BoardJoinLimitErrorCode, BoardJoinLimitContent> = {
  user_board_plan_limit_exceeded: {
    title: "Limite de l'offre Gratuite atteinte",
    message:
      "Vous avez atteint la limite de 3 tableaux incluse dans votre offre Gratuite. Passez à une offre Premium pour rejoindre ce tableau.",
    secondary:
      "Cette invitation reste en attente : vous pourrez l'accepter depuis cette page après votre passage à Premium.",
    ctaLabel: 'Passer à Premium',
  },
  user_board_overage_payment_required: {
    title: "Limite de l'offre Premium atteinte",
    message:
      "Vous avez atteint la limite de tableaux incluse dans votre offre Premium. Pour rejoindre ce tableau supplémentaire, vous devez régler un dépassement.",
    secondary:
      "Cette invitation reste en attente : vous pourrez l'accepter depuis cette page après le règlement du dépassement.",
    ctaLabel: 'Gérer mes dépassements',
  },
};

export const isBoardJoinLimitErrorCode = (code: unknown): code is BoardJoinLimitErrorCode =>
  typeof code === 'string' && (BOARD_JOIN_LIMIT_ERROR_CODES as string[]).includes(code);

export const getBoardJoinLimitContent = (code: BoardJoinLimitErrorCode): BoardJoinLimitContent =>
  BOARD_JOIN_LIMIT_CONTENT[code];
